module.exports = __webpack_public_path__ + "img/no-credit-card-found.d4af752d.png";